import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PlusCircle, FileText, UserPlus, BarChart3 } from "lucide-react";
import { useProductContext } from "@/contexts/ProductContext";

/**
 * Section 5 — Quick actions.
 * Primary teal "Post New Load" + secondary, outline, and ghost actions.
 * "View All Reports" is intentionally disabled until a reports page exists.
 */
export function QuickActions() {
  const navigate = useNavigate();
  const { context: productContext } = useProductContext();
  const isLRDirect = productContext === "lr-direct";

  return (
    <section className="rounded-lg border bg-card p-4">
      <h3 className="mb-3 text-sm font-bold text-foreground">Quick Actions</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        <Button
          onClick={() =>
            navigate(
              isLRDirect
                ? "/lr-direct/post?mode=load&visibility=private_only"
                : "/post"
            )
          }
          className="h-11 gap-2 font-semibold text-foreground hover:opacity-90"
          style={{ backgroundColor: "#02ffd3" }}
        >
          <PlusCircle className="h-4 w-4" />
          Post New Load
        </Button>
        <Button
          variant="secondary"
          onClick={() =>
            navigate(
              isLRDirect
                ? "/lr-direct/post?mode=quote&visibility=private_only"
                : "/lr-direct/post?mode=quote&visibility=private_only"
            )
          }
          className="h-11 gap-2"
        >
          <FileText className="h-4 w-4" />
          Send Quote Request
        </Button>
        <Button
          variant="outline"
          onClick={() => navigate("/lr-direct/network-settings?invite=1")}
          className="h-11 gap-2"
        >
          <UserPlus className="h-4 w-4" />
          Invite Broker
        </Button>
        <Button
          variant="ghost"
          disabled
          className="h-11 gap-2"
          title="Reports coming soon"
        >
          <BarChart3 className="h-4 w-4" />
          View All Reports
        </Button>
      </div>
    </section>
  );
}
